import Immutable from 'immutable';
import { MENU_SEARCH_INPUT_MOBILE_STATE } from '../actions/header/menu';

const MENU = 'menu';
const SEARCH = 'search';
const MOBILE_STATE = 'mobileState';

const initialState = Immutable.fromJS({
    search: {
        mobileState: false,
    },
});

export default function menu(state = initialState, action) {
    switch (action.type) {
        case MENU_SEARCH_INPUT_MOBILE_STATE:
            return state.setIn([SEARCH, MOBILE_STATE], action.payload);
        default:
            return state;
    }
}

export const menuSearchInputMobileStateSelector = (state) => state.getIn([MENU, SEARCH, MOBILE_STATE]);
